<template>
  <div class="blumar-alert">
    <b-alert :show="show" :variant="alertStyle" dismissible fade @dismissed="hide()">{{alertText}}</b-alert>
  </div>
</template>

<script>
export default {
  methods: {
    hide() {
      this.$store.dispatch("hideAlert");
    }
  },
  computed: {
    show() {
      return this.$store.getters.showAlert;
    },
    alertText() {
      return this.$store.getters.alertMessage;
    },
    alertStyle() {
      return this.$store.getters.alertStyle;
    }
  }
};
</script>

<style scoped>
.blumar-alert {
  position: fixed;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 1000000;
  bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/BlumarAlert.vue